import React from 'react';
import './Facts.css';

const Facts = () => {
  const factItems = [
    {
      icon: "flaticon-worker",
      count: 30,
      text: "Expert Staffs"
    },
    {
      icon: "flaticon-building",
      count: 50,
      text: "Happy Clients"
    },
    {
      icon: "flaticon-address",
      count: 220,
      text: "Completed Projects"
    },
    {
      icon: "flaticon-crane",
      count: 8,
      text: "Running Projects"
    }
  ];

  return (
    <div className="fact">
      <div className="container-fluid">
        <div className="row counters">
          <div className="col-md-6 fact-left wow slideInLeft">
            <div className="row">
              {factItems.slice(0, 2).map((item, index) => (
                <div key={index} className="col-6">
                  <div className="fact-icon">
                    <i className={item.icon}></i>
                  </div>
                  <div className="fact-text">
                    <h2 data-toggle="counter-up">{item.count}</h2>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-6 fact-right wow slideInRight">
            <div className="row">
              {factItems.slice(2, 4).map((item, index) => (
                <div key={index} className="col-6">
                  <div className="fact-icon">
                    <i className={item.icon}></i>
                  </div>
                  <div className="fact-text">
                    <h2 data-toggle="counter-up">{item.count}</h2>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facts;